'use client';

import { FC } from 'react';
import { EventData } from '../types';
import { useTrackEventOnce } from '../hooks';
type Props = {
  event: EventData;
};
export const TrackClientEvent: FC<Props> = ({
  event
}) => {
  useTrackEventOnce(event);
  return null;
};